import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArticleCard from "@/components/feature/ArticleCard";
import SEOHelmet from "@/components/feature/SEOHelmet";
import JsonLd from "@/components/feature/JsonLd";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-4">
            分类未找到
          </h1>
          <Link
            to="/"
            className="text-primary-600 hover:text-primary-700 transition-colors text-sm"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const canonicalUrl = `https://whxinantec.cn/category/${slug}`;

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${category.name} - 黑料bu打烊`,
    description: category.description,
    url: canonicalUrl,
    isPartOf: {
      "@type": "WebSite",
      name: "黑料bu打烊",
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHelmet
        title={`${category.name} - 黑料bu打烊 | 明星八卦黑料聚合平台`}
        description={category.description}
        keywords={`${category.name},黑料bu打烊,明星黑料,娱乐圈爆料,吃瓜平台`}
        canonicalUrl={canonicalUrl}
      />
      <JsonLd data={webpageSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: "首页", path: "/" },
                  { label: "分类浏览", path: "/category/zuixin-baoliao" },
                  { label: category.name },
                ]}
              />
            </div>
          </div>

          {/* Category Header */}
          <section className="w-full bg-background-100 py-8 md:py-12">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100">
                  <i
                    className={`${category.icon} text-accent-600 text-xl md:text-2xl`}
                  ></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                    {category.name}
                  </h1>
                  <p className="text-sm text-foreground-600 mt-1">
                    {category.description}
                  </p>
                </div>
              </div>

              {/* Category tabs */}
              <div className="flex items-center gap-2 flex-wrap mt-6">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      cat.slug === slug
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200"
                    }`}
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Articles Grid */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {categoryArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                    <i className="ri-inbox-line text-foreground-400 text-xl"></i>
                  </div>
                  <p className="text-foreground-600">
                    该分类暂无文章
                  </p>
                </div>
              )}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}